import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {
  resetCustomisationState,
  updateEditState,
  updatefinishedEditingState,
} from "../customisation-slice";

const propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export const SidebarAnimationContext = createContext([]);

export const useSidebarAnimationContext = () =>
  useContext(SidebarAnimationContext);

export const SidebarAnimationProvider = ({ children }) => {
  const [animationState, setAnimationState] = useState("ENTERING");
  const dispatch = useDispatch();

  const updateFinishedEditingStateWithAnimation = (value) => {
    setAnimationState("LEAVING");
    setTimeout(() => {
      dispatch(updatefinishedEditingState(value));
      setAnimationState("ENTERING");
    }, 200);
  };

  const updateEditStateWithAnimation = (value) => {
    setAnimationState("LEAVING");
    setTimeout(() => {
      dispatch(updateEditState(value));
      setAnimationState("ENTERING");
    }, 200);
  };

  const resetCustomisationStateWithAnimation = () => {
    setAnimationState("LEAVING");
    setTimeout(() => {
      dispatch(resetCustomisationState());
      setAnimationState("ENTERING");
    }, 200);
  };

  return (
    <SidebarAnimationContext.Provider
      value={{
        animationState,
        updateEditStateWithAnimation,
        updateFinishedEditingStateWithAnimation,
        resetCustomisationStateWithAnimation,
      }}
    >
      {children}
    </SidebarAnimationContext.Provider>
  );
};

SidebarAnimationProvider.propTypes = propTypes;

export default SidebarAnimationProvider;
